import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class ExerciseService {
    constructor(private http: HttpClient) {}

    getExercise(exerciseId: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/tasks/exercise/${exerciseId}/`);
    }
}
